export default __webpack_public_path__ + "static/media/udaipur1.16dc45ae.jpg";